/* Temporary fix; create-react-app doesn't support the .jsx extention */
import 'index.jsx';



// WEBPACK FOOTER //
// ./src/index.js